(function () {
  function setCartAttribute(value) {
    return fetch(window.routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { ab_free_shipping_variant: value } }),
    })
      .then((response) => response.json())
      .then((updatedCart) => {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ab-free-shipping', cartData: updatedCart });
      });
  }

  function applyFreeShippingVariant() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const currentAttribute = cart.attributes && cart.attributes.ab_free_shipping_variant;

        if (window.abFreeShippingVariant === 'B') {
          if (currentAttribute === 'B') return;
          return setCartAttribute('B');
        }

        if (currentAttribute === 'A') return;
        return setCartAttribute('A');
      })
      .catch((error) => console.error('ab-free-shipping:', error));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFreeShippingVariant);
  } else {
    applyFreeShippingVariant();
  }
})();
